import {User} from './user.model';
export class SignUpModel {
  email: string;
  password: string;
  userData: User;
}
